export const MONEY = 'money';
export const UP = 'up';
export const DOWN = 'down';
export const UPCOMINGVALUE = 'upcomingValue';
